<template>
    <div>
        <div class="sidenav">
            <p class="sidenav-title">Getting Started</p>
            <router-link class="button-sidenav active" to="/">Setup</router-link>
            <p class="sidenav-title">Components</p>
            <router-link class="button-sidenav active" to="/lib/avatar">Avatar</router-link>
            <router-link class="button-sidenav active" to="/lib/badge">Badge</router-link>
            <router-link class="button-sidenav active" to="/lib/button">Button</router-link>
            <router-link class="button-sidenav active" to="/lib/charts">Charts</router-link>
            <router-link class="button-sidenav active" to="/lib/checkbox">Checkbox</router-link>
            <router-link class="button-sidenav active" to="/lib/collapse">Collapse</router-link>
            <router-link class="button-sidenav active" to="/lib/dropmenu">Dropmenu</router-link>
            <router-link class="button-sidenav active" to="/lib/input">Input</router-link>
            <router-link class="button-sidenav active" to="/lib/modal">Modal</router-link>
            <router-link class="button-sidenav active" to="/lib/notice">Notice</router-link>
            <router-link class="button-sidenav active" to="/lib/popover">Popover</router-link>
            <router-link class="button-sidenav active" to="/lib/progress">Progress</router-link>
            <router-link class="button-sidenav active" to="/lib/radio">Radio</router-link>
            <router-link class="button-sidenav active" to="/lib/sidemenu">Sidemenu</router-link>
            <router-link class="button-sidenav active" to="/lib/selector">Selector</router-link>
            <router-link class="button-sidenav active" to="/lib/slider">Slider</router-link>
            <router-link class="button-sidenav active" to="/lib/spinner">Spinner</router-link>
            <router-link class="button-sidenav active" to="/lib/switch">Switch</router-link>
            <router-link class="button-sidenav active" to="/lib/table">Table</router-link>
            <router-link class="button-sidenav active" to="/lib/tabs">Tabs</router-link>
            <p class="sidenav-title">Templates</p>
            <router-link class="button-sidenav active" to="/lib/temp-dashboard">Dashboard</router-link>
            <router-link class="button-sidenav active" to="/lib/temp-table">Table</router-link>
            <router-link class="button-sidenav active" to="/lib/temp-form">Form</router-link>
        </div>

        <c-flex class="section">
            <div>
                <!-- navbar zindex -->
                <router-view @open="open" />
            </div>
        </c-flex>
    </div>
</template>

<script>
import { CFlex } from "@chakra-ui/vue";

export default {
    components: {
        CFlex
    },

    // navbar zindex //
    methods: {
        open(index) {
            this.$emit('open', index);
        }
    }
}
</script>




<style lang="scss">
@import '@/scss/styles.scss'
</style>
